import { render, staticRenderFns } from "./Benutzergruppen.vue?vue&type=template&id=9dc7a346&"
import script from "./Benutzergruppen.vue?vue&type=script&lang=js&"
export * from "./Benutzergruppen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports